import { SVGProps } from 'react';

const SvgPackageMoveSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M10.667 2.833c-.249 0-.49.069-.703.197l-3.11 1.867h-.002a1.412 1.412 0 0 0-.504.529c-.12.216-.181.46-.181.707v3.735c0 .246.062.49.181.706.12.217.292.4.504.528l.002.001 3.109 1.866h.001c.21.128.45.197.697.198h.011c.247-.001.487-.07.697-.197h.001l3.11-1.867h.002c.211-.13.384-.312.503-.529.12-.216.181-.46.182-.707V6.132c0-.246-.063-.49-.182-.706-.119-.217-.292-.4-.503-.528L11.37 3.03a1.357 1.357 0 0 0-.703-.198Zm3.296 7.414-2.796 1.678V8.31l3-1.5v3.058a.47.47 0 0 1-.058.225.417.417 0 0 1-.146.155Zm-3.796 1.678V8.31l-3-1.5v3.058c0 .08.02.158.057.225a.413.413 0 0 0 .146.154l2.797 1.68Zm.315-8.04a.356.356 0 0 1 .37 0l3.112 1.868a.396.396 0 0 1 .033.023l-3.33 1.665-3.33-1.665a.384.384 0 0 1 .033-.023l3.11-1.866.002-.001Zm-9.149.948a.5.5 0 1 0 0 1H4a.5.5 0 1 0 0-1H1.333ZM.833 8a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H1.333a.5.5 0 0 1-.5-.5Zm.5 2.167a.5.5 0 1 0 0 1H4a.5.5 0 0 0 0-1H1.333Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPackageMoveSmall;
